/* eslint-disable react/no-unescaped-entities */
import React from 'react';
// fichier css
import './AskList.scss';
import { Dropdown } from 'react-bootstrap';

// data
import CarteParticulier from './CarteParticulier';
import dataGuilhem from '../data/dataGuilhem';

// burger
const AskList = function AskList() {
  const [category, setCategory] = React.useState('all');
  return (
    <>
      <div className="w-full flex flex-col mt-4 text-center">
        <div className="flex flex-col  text-center">
          <h1 className="text-3xl font-medium">AlloMano?</h1>
          <p className="text-lg">Helping other peoples with their tasks! </p>
        </div>
        <div className="flex flex-col md:flex-row m-auto">
          <Dropdown className="m-8">
            <Dropdown.Toggle className="buttontuto" id="dropdown-basic">
              Category
            </Dropdown.Toggle>
            <Dropdown.Menu>
              <Dropdown.Item onClick={() => setCategory('garden')}>
                Garden
              </Dropdown.Item>
              <Dropdown.Item onClick={() => setCategory('exterior')}>
                Exterior
              </Dropdown.Item>
              <Dropdown.Item onClick={() => setCategory('interior')}>
                Interior
              </Dropdown.Item>
              <Dropdown.Item onClick={() => setCategory('bathroom')}>
                Bathroom
              </Dropdown.Item>
              <Dropdown.Item onClick={() => setCategory('all')}>
                All requests
              </Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>
          <div className="my-auto w-48">
            <button type="button" className="button text-base">
              Add request
            </button>
          </div>
        </div>
      </div>

      {/* // bloc principal */}
      <div className="lg:flex align-center w-full m-auto lg:w-5/6 lg:rounded-lg  :flex flex-col lg:flex-col p-2">
        {/* <div className="shadow align-center w-full lg:m-6 lg:rounded-lg  :flex flex-col lg:flex-col p-2"> */}
        {dataGuilhem
          .filter((data) => category === 'all' || data.category === category)
          .map((el) => (
            <div className="shadow flex flex-col lg:flex-row w-full my-2 mb-5 bg-gray-200 py-5 lg:rounded-3xl items-center">
              <div className="lg:w-3/4 h-full w-full lg:py-auto lg:my-auto mx-auto">
                <CarteParticulier
                  img={el.img}
                  name={el.name}
                  ville={el.ville}
                  vote={el.vote}
                />
              </div>
              <div className="w-full text-center font-medium flex flex-col">
                <h1 className="text-3xl mb-8 flex w-full text-center font-bold place-content-center ">
                  {el.titre}
                </h1>

                <div className="flex flex-col mb-2 lg:mb-0">
                  <h1 className="underline-offset-1 text-2xl lg:text-xl mr-2 underline underline-offset-4">
                    Description:
                  </h1>
                  <h2 className="text-lg mb-4">{el.description}</h2>
                </div>
                <div className="flex flex-col mb-2 lg:mb-0">
                  <h1 className="underline-offset-1 text-2xl lg:text-xl mr-2 underline underline-offset-4">
                    Détails:
                  </h1>
                  <h2 className="text-lg mb-4">{el.details}</h2>
                </div>
                <div className="flex flex-col mb-2 lg:mb-0">
                  <h1 className="underline-offset-1 text-2xl lg:text-xl mr-2 underline underline-offset-4">
                    Available:
                  </h1>
                  <h2 className="text-xl mb-4">{el.time}</h2>
                </div>
              </div>
            </div>
          ))}
        {/* </div> */}
        {/* Fin 2nd bloc */}
      </div>
    </>
  );
};

export default AskList;
